import B2becTranslation from '@/components/B2becTranslation'
import FormatPrice from '@/components/FormatPrice'

import CheckoutNameBlock from '../../components/CheckoutNameBlock'

// TODO: Check this component after the refactor
const MiddleSection = (currencyUnit) => {
  return [
    {
      title: '',
      dataIndex: 'imgUrl',
      key: 'imgUrl',
      width: '7%',
      render: (text) => (
        <img
          alt={text}
          className="order-overview__middle-section__table__image"
          src={text}
        />
      ),
    },
    {
      title: <B2becTranslation value="checkout.step3.middleSection.table.materialNumber" />,
      dataIndex: 'materialNumber',
      key: 'materialNumber',
      align: 'left',
      render: (text) => <p>{text}</p>,
    },
    {
      title: (
        <div className="checkout-name-title__wrapper">
          <B2becTranslation value="checkout.step3.middleSection.table.name" />
          <B2becTranslation value="checkout.step3.middleSection.table.quantity" />
        </div>
      ),
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      render: (_, record) => <CheckoutNameBlock record={record} />,
    },
    {
      title: <B2becTranslation value="checkout.step3.middleSection.table.price" />,
      dataIndex: 'price',
      key: 'price',
      align: 'right',
      render: (text) => <FormatPrice currencyUnit={currencyUnit} price={text} />,
    },
    {
      title: <B2becTranslation value="checkout.step3.middleSection.table.total" />,
      dataIndex: 'total',
      key: 'total',
      align: 'right',
      render: (text) => {
        return (
          <div className="order-overview__middle-section__table__total-column">
            <FormatPrice
              className="order-overview__middle-section__table__total-column__price"
              currencyUnit={currencyUnit}
              price={text}
            />
          </div>
        )
      },
    },
  ]
}

export default MiddleSection
